
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.664 11l1.333 1.333-1.333 1.334M14 12.334h-4","stroke":"#221B38","stroke-width":".8","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14.5 9.25a3.751 3.751 0 00-5.25 5.25h-7.5a.752.752 0 01-.75-.75v-12c0-.413.337-.75.75-.75h9.443c.194 0 .39.083.524.218l2.566 2.565c.135.135.217.33.217.525V9.25zM8.576 11.5H4.001M4.001 7.75h7.5M4.001 4h3.75","stroke":"#221B38","stroke-width":"1.3","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.25 16a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5zM10.75 1v3.75h3.75v-.442a.757.757 0 00-.217-.525l-2.566-2.566A.757.757 0 0011.194 1h-.443z","stroke":"#221B38","stroke-width":"1.3","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    